import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Box, Typography, List, ListItem, ListItemText } from "@mui/material";
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';

interface ActiveSession {
  device: string;
  lastSeen: string;
  ipAddress: string;
}

interface Props {
  open: boolean;
  handleClose: () => void;
  handleContinue: () => void;
  message: string;
  activeSessions: ActiveSession[];
}

const SessionExistsModal = (props: Props) => {
  const { open, handleClose, handleContinue, message, activeSessions } = props;

  const formatDate = (dateString: string) => {
    try {
      const date = new Date(dateString);
      return date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    } catch (e) {
      return dateString;
    }
  };

  return (
    <Dialog 
      open={open} 
      onClose={handleClose} 
      PaperProps={{ sx: { borderRadius: 3, minWidth: 450, maxWidth: 600 } }}
    >
      <DialogTitle sx={{ textAlign: 'center', fontWeight: 700, fontSize: 20 }}>
        <WarningAmberRoundedIcon color="warning" sx={{ fontSize: 40, mb: 1 }} />
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ textAlign: 'center', fontSize: 16, mt: 1, mb: 2 }}>
          {message}
        </Typography>
        
        {activeSessions && activeSessions.length > 0 && (
          <Box sx={{ mt: 2 }}>
            <Typography sx={{ fontSize: 14, fontWeight: 600, mb: 1 }}>
              Active Sessions:
            </Typography>
            <List sx={{ bgcolor: 'background.paper', borderRadius: 1, border: '1px solid #e0e0e0' }}>
              {activeSessions.map((session, index) => (
                <ListItem key={index} sx={{ flexDirection: 'column', alignItems: 'flex-start', py: 1.5 }}>
                  <ListItemText
                    primary={
                      <Typography sx={{ fontWeight: 500, fontSize: 14 }}>
                        {session.device}
                      </Typography>
                    }
                    secondary={
                      <Box sx={{ mt: 0.5 }}>
                        <Typography variant="body2" color="text.secondary" sx={{ fontSize: 12 }}>
                          Last seen: {formatDate(session.lastSeen)}
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ fontSize: 12 }}>
                          IP Address: {session.ipAddress}
                        </Typography>
                      </Box>
                    }
                  />
                </ListItem>
              ))}
            </List>
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', pb: 2, px: 3 }}>
        <Button 
          onClick={handleContinue} 
          variant="contained" 
          color="primary" 
          sx={{ minWidth: 120, mr: 1 }}
        >
          Continue Login
        </Button>
        <Button 
          onClick={handleClose} 
          variant="outlined" 
          color="inherit" 
          sx={{ minWidth: 100 }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SessionExistsModal;

